export type DrivingCameraMode = 'chase' | 'hood' | 'bumper' | 'cockpit';

export interface DrivingCameraOption {
  id: DrivingCameraMode;
  name: string;
  description: string;
  icon: string;
  fov: number;
}

export const drivingCameraOptions: readonly DrivingCameraOption[] = [
  { id: 'chase', name: '추격', description: '차량 뒤를 부드럽게 추적', icon: '◉', fov: 48 },
  { id: 'hood', name: '보닛', description: '보닛 위 낮은 시점', icon: '▰', fov: 58 },
  { id: 'bumper', name: '범퍼', description: '노면에 가까운 속도 시점', icon: '▾', fov: 66 },
  { id: 'cockpit', name: '운전석', description: '차량 내부 1인칭 시점', icon: '⌾', fov: 70 },
];

export const DEFAULT_DRIVING_CAMERA_MODE: DrivingCameraMode = 'chase';

export function findDrivingCameraById(id: string): DrivingCameraOption | undefined {
  return drivingCameraOptions.find((option) => option.id === id);
}
